import { LiteralHeadersTableTitles, RouteTypes } from 'consts';
import FilterListPractice from 'containers/filterCertificadosPracticas';
import Header from 'containers/Header';
import Table from 'containers/TableCertificados';
import { useList } from 'hooks/list';
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  postUpdateUltimoAviso,
  setModalDraftType,
  setMsgSubmit,
  setLoading,
} from 'store/app/actions';
import {
  makeSelectInfoUserProfileSelected,
  makeSelectModalDraftType,
  makeSelectMsgSubmit,
} from 'store/app/selectors';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import {
  getPracticas,
  getPracticasCount,
  setPracticasCount2,
  resetState,
} from 'store/practicas/actions';
import {
  makeSelectPracticasList,
  makeSelectPracticasListCount,
  makeSelectSelectedPage,
  makeSelectElementsPerPage,
} from 'store/practicas/selectors';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import {
  parseDate,
  parsePracticeStatus,
  parseTime,
} from 'utils/parsePractices';
import { getDefaultStatus } from 'utils/practiceUtils';
import './practice-list.scss';

import { getCursos } from 'store/cursos/actions';

const selectors: any = createStructuredSelector({
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  practicas: makeSelectPracticasList(),
  practicasCount: makeSelectPracticasListCount(),
  infoUserProfile: makeSelectInfoUserProfileSelected(),
  pageNumber: makeSelectSelectedPage(),
  pageResults: makeSelectElementsPerPage(),
} as any);

const options =
  '[{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "asc"},"active": "true"},{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "asc"},"active": "false"}]';

export const listPracticasConstant = 'Certificados de prácticas';

const formatStation = (code: string | null, description: string | null): string => {
  if (!code && !description) {
    return '-';
  }

  const stationCode = code && code !== null ? code : '';
  const stationDescription = description && description !== null ? description : '';

  return `${stationCode} - ${stationDescription}`;
};

const getUserProfileText = (item: any): string => {
  if (item.usuario_nombre_perfil) {
    return item.usuario_nombre_perfil;
  }

  if (item.usuario_perfil_parsed === 'ALUMNO') {
    return `${item.usuario_perfil_parsed} - ${item.usuario_tipo_ie_parsed}`;
  }

  return item.usuario_perfil_parsed;
};

const buildCommonFields1 = (item: any) => {
  const link = '/listado-alumnos/' + item.ID_CURSO;

  return [
    {
      text: item.ID_CURSO,
      urlLink: link,
    },
    {
      text:
        item.HORA_INI_PUESTA_DISP !== null
          ? parseTime(item.HORA_INI_PUESTA_DISP)
          : ' - ',
    },
    {
      text:
        parseDate(item.FECHA_INI_SERVICIO) +
        ' ' +
        parseTime(item.HORA_INI_SERVICIO),
    },
    {
      text:
        parseDate(item.FECHA_FIN_SERVICIO) +
        ' ' +
        parseTime(item.HORA_FIN_SERVICIO),
    },
    { text: item.MIN_PRACTICA },
    {
      text: item.ID_TIPO_PRACTICA !== '' ? item.DESC_PRACTICA : '',
    },
    {
      tooltip: [
        {
          title: 'NºTren: ',
        },
        {
          paragraph: item.NUM_TREN ? item.NUM_TREN : '-',
        },
        {
          title: 'Estación Inicio: ',
        },
        {
          paragraph: formatStation(
            item.COD_ESTACION_INI,
            item.DESC_ESTACION_INI
          ),
        },
        {
          title: 'Estación Fin: ',
        },
        {
          paragraph: formatStation(
            item.COD_ESTACION_FIN,
            item.DESC_ESTACION_FIN
          ),
        },
      ],
    },
  ];
};

const buildInfoUser = (item: any) => [
  item.ID_ALUMNO
    ? {
        text: item.ID_ALUMNO + ' - ' + item.nombre_usuario_parsed,
        tooltip: [
          {
            title: 'Observaciones alumno: ',
          },
          {
            paragraph:
              item.OBSERVACIONES_ALUMNO !== null
                ? item.OBSERVACIONES_ALUMNO
                : 'No hay observaciones del alumno',
          },
        ],
        className: item.ID_ALUMNO ? 'position_icon' : '',
      }
    : {
        text: '',
      },
  {
    text: getUserProfileText(item),
  },
];

const buildInstructorField = (item: any) => [
  item.ID_INSTRUCTOR
    ? {
        text: item.ID_INSTRUCTOR
          ? item.ID_INSTRUCTOR + ' - ' + item.NOMBRE_INSTRUCTOR
          : '',
        tooltip: [
          {
            title: 'Observaciones instructor: ',
          },
          {
            paragraph:
              item.OBSERVACIONES_INSTRUCTOR !== null
                ? item.OBSERVACIONES_INSTRUCTOR
                : ' No hay observaciones del instructor',
          },
        ],
        className: item.ID_ALUMNO ? 'position_icon' : '',
      }
    : {
        text: '',
      },
];

const buildCommonFields2 = (item: any): any[] => [
  {
    text: parsePracticeStatus(item.ID_EST_PRACTICA),
  },
  {
    urlIcon: RouteTypes.DETAIL.replace(':id', String(item?.ID_PRACTICA)),
    ariaLabelIcon: 'Abrir modal',
    label: item.ID_PRACTICA,
  },
];

const buildPracticaParsed = (item: any) => {
  let data: any[] = [...buildCommonFields1(item)];

  data = [...data, ...buildInstructorField(item)];
  data = [...data, ...buildInfoUser(item)];
  data = [...data, ...buildCommonFields2(item)];

  return {
    table: [data],
  };
};

const CertificadosPracticas = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [numPracticas, setNumPracticas] = useState();
  const [openInit, setOpenInit] = useState(false);
  const [modalType, setModalType] = useState('');
  const [msgModal, setMsgModal] = useState('');
  const [tipoPracticaConduccionEfectiva] = useState(['CT', 'AC', 'MA']);

  const [itemsOnLeftByProfile, setitemsOnLeftByProfile] = useState(5);

  const defaultLinks = [
    {
      label: listPracticasConstant,
      link: RouteTypes.CERTIFICADOS_PRACTICAS,
      textHelp: listPracticasConstant,
      active: true,
    },
  ];

  const links = defaultLinks;

  const {
    access_token,
    msgSubmit,
    modalDraftType,
    profileActive,
    practicas,
    practicasCount,
    infoUserProfile,
    pageNumber,
    pageResults,
  } = useSelector<any, any>(selectors);
  const [list] = useState(true);

  const redirect = (e: any) => {
    history.push(e.detail);
  };

  useEffect(() => {
    const practicasFiltradasTipo = practicas.filter((p) =>
      tipoPracticaConduccionEfectiva.includes(p.ID_TIPO_PRACTICA)
    );
    setNumPracticas(practicasFiltradasTipo.length);
  }, [practicasCount, practicas]);

  const defaultEmptyFilter = {
    alumnos: '',
    ascDesc: '',
    cursos: '',
    elemFin: 2147483647,
    elemInicio: 0,
    estados: 'VA,RE,,PV',
    fechaFin: 9999999999999,
    fechaInicio: 0,
    instructores: '',
    orden: '',
    sociedades: '',
    savedValues: false,
    lastProfile: profileActive?.ID_PERFIL,
  };

  const [initFilter, setInitFilter] = useState(
    window.location.pathname === RouteTypes.HOME
      ? JSON.parse(
          sessionStorage.getItem(`savedFilter-${window.location.pathname}`) ??
            JSON.stringify(defaultEmptyFilter)
        )
      : defaultEmptyFilter
  );

  useEffect(() => {
    const savedFilterHome = JSON.parse(
      sessionStorage.getItem(`savedFilter-${window.location.pathname}`) ??
        JSON.stringify(defaultEmptyFilter)
    );

    if (
      savedFilterHome.savedValues === true &&
      savedFilterHome.lastProfile === profileActive?.ID_PERFIL
    ) {
      setInitFilter(savedFilterHome);
    } else if (
      savedFilterHome.savedValues === false ||
      savedFilterHome.lastProfile !== profileActive?.ID_PERFIL
    ) {
      setInitFilter(defaultEmptyFilter);
    }
  }, [profileActive]);

  useEffect(() => {
    document.body.addEventListener('mousemove', () => {
      const aux = document.querySelector(
        'div.ui-lateral-menu > button.ui-lateral-menu__menu-button'
      );
      const isContained = aux?.classList.contains(
        'ui-lateral-menu__menu-button--open'
      );
      if (!isContained) {
        const uls = document.querySelectorAll(
          'div.ui-lateral-menu ul.ui-lateral-menu__sublink-list--open'
        );
        uls.forEach((ul) => {
          ul.classList.remove('ui-lateral-menu__sublink-list--open');
        });
      }
    });
  }, []);

  useEffect(() => {
    const filter = getDefaultStatus(profileActive, {
      ...initFilter,
      alumnos: initFilter.alumnos,
      cursos: initFilter.cursos,
    });
    setInitFilter(filter);
    dispatch(resetState());
  }, [profileActive]);

  const filtroCurso = {
    elemInicio: 0,
    elemFinal: 2147483647,
    orden: '',
    ascDesc: '',
    fechaInicio: 0,
    fechaFin: 9999999999999,
    sociedades: '',
    estados: '',
    cursos: '',
    provincias: '',
  };

  const {
    data,
    setData,
    headers,
    setHeaders,
    handleFilterTable,
    handleFilterChange,
  } = useList(
    { ...initFilter },
    [],
    {
      action: (filter) => {
        sessionStorage.setItem(
          `savedFilter-${window.location.pathname}`,
          JSON.stringify({ ...filter, savedValues: true })
        );
        return dispatch(getPracticas(filter));
      },
      headerToAPIMap: {
        'Inicio  Serv.': 'FECHA_INI_SERVICIO',
        'Fin  Serv.': 'FECHA_FIN_SERVICIO',
      },
    },
    (filter) => {
      dispatch(setPracticasCount2(0));
      dispatch(getPracticas(filter));
      dispatch(getPracticasCount(filter));
      filtroCurso.cursos = filter.cursos;
      dispatch(getCursos(filtroCurso));
    },
    async () => {
      dispatch(setLoading(true));
      await new Promise((resolve) => setTimeout(resolve, 90));
      dispatch(setLoading(false));
    }
  );

  function confirmGoProfile() {
    dispatch(postUpdateUltimoAviso());
    setOpenInit(false);
    setModalType('');
    setMsgModal('');
    setTimeout(() => {
      history.push(RouteTypes.PROFILE);
    }, 500);
  }

  function rejectGoProfile() {
    dispatch(postUpdateUltimoAviso());
    setOpenInit(false);
    setModalType('');
    setMsgModal('');
  }

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    const commonFields1 = [{ text: LiteralHeadersTableTitles.CURSO }];

    const commonFields1_1 = [
      {
        text: 'Inicio  Serv.',
        orderBy: true,
        ariaLabelIcon: 'Icono de ordenar',
      },
      {
        text: 'Fin  Serv.',
        orderBy: true,
        ariaLabelIcon: 'Icono de ordenar',
      },
      { text: LiteralHeadersTableTitles.MINUTOS },
      { text: LiteralHeadersTableTitles.TIPO_PRACTICA },
      { text: LiteralHeadersTableTitles.TREN },
    ];

    const horaPuestaDisp = [
      { text: LiteralHeadersTableTitles.HORA_PUESTA_DISP },
    ];

    const userInfoFields = [
      { text: LiteralHeadersTableTitles.ALUMNO },
      { text: LiteralHeadersTableTitles.NOMBRE_PERFIL },
    ];

    const instructorFields = [{ text: LiteralHeadersTableTitles.INSTRUCTOR }];

    const commonFields2: any = [
      { text: LiteralHeadersTableTitles.ESTADO, hideResponsive: false },
      {
        text: LiteralHeadersTableTitles.VER,
        hideResponsive: true,
      },
    ];

    let headers: any[] = [
      ...commonFields1,
      ...horaPuestaDisp,
      ...commonFields1_1,
    ];
    headers = [...headers, ...instructorFields];
    headers = [...headers, ...userInfoFields];
    headers = [...headers, ...commonFields2];
    setHeaders(headers);
  }, [practicas, profileActive, practicasCount]);

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    const practicasParsed = practicas
      .filter((p) => tipoPracticaConduccionEfectiva.includes(p.ID_TIPO_PRACTICA))
      .slice(
        (pageNumber - 1) * pageResults,
        (pageNumber - 1) * pageResults + pageResults
      )
      .map((item) => buildPracticaParsed(item));

    setData(practicasParsed);
  }, [practicas, profileActive, practicasCount]);

  useEffect(() => {
    if (
      profileActive?.ID_PERFIL.startsWith('12') &&
      infoUserProfile.MOSTRAR_AVISO === 'S'
    ) {
      setOpenInit(true);
      setMsgModal(
        'Para un mejor seguimiento por parte de los instructores, formadores, gestores y administradores, es conveniente que suba a su perfil una foto actual para que estos usuarios puedan identificarlo más fácilmente '
      );
      setModalType('confirm');
    } else {
      setModalType('');
      setMsgModal('');
      setOpenInit(false);
    }
  }, [infoUserProfile.MOSTRAR_AVISO]);

  useEffect(() => {
    if (profileActive) {
      switch (profileActive.ID_PERFIL) {
        case '111':
        case '121':
        case '122':
        case '123':
          setitemsOnLeftByProfile(4);
          break;
        case '211':
        case '311':
        case '411':
        case '511':
          setitemsOnLeftByProfile(5);
          break;
      }
    }
  }, [profileActive]);

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list-certificados">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">{listPracticasConstant}</h1>
        <FilterListPractice
          handleSubmit={handleFilterChange}
          initValues={initFilter}
        />
        <RfUiModal
          title-modal={msgModal}
          modalConfirmText="Ir al perfil"
          id-modal="modalDraft"
          modal-type={modalType}
          onModalClose={rejectGoProfile}
          onConfirm={confirmGoProfile}
        ></RfUiModal>
        <Table
          openInit={openInit}
          redirect={(e: any) => {
            redirect(e);
          }}
          list={list}
          headers={headers}
          data={data}
          orderMobile={true}
          orderOptions={options}
          dataCount={numPracticas}
          handleFilter={handleFilterTable}
          hideAudit={true}
          itemsOnLeft={itemsOnLeftByProfile}
          showButtonDetail={true}
        />
        <RfUiModal
          title-modal={msgSubmit}
          modalConfirmText="Aceptar"
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
          onConfirm={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </>
  );
};

export default CertificadosPracticas;